import dayjs from 'dayjs';
import { Button, Form } from 'antd';
import { useEffect, useState } from 'react';
// import CustomAccordion from '../CustomAccordion';
import CardAccordion from 'components/CardAccordion/CardAccordion';
import { Box, Chip, Grid, Table, TableRow, TableBody, TableCell, TableHead, Typography, TableContainer } from '@mui/material';

const getOrdinalSuffix = (num) => {
	const j = num % 10;
	const k = num % 100;
	if (j === 1 && k !== 11) {
		return num + 'st';
	}
	if (j === 2 && k !== 12) {
		return num + 'nd';
	}
	if (j === 3 && k !== 13) {
		return num + 'rd';
	}
	return num + 'th';
};

const accordionSx = {
	mb: 2,
	border: '1px solid #e6ebf2',
	borderRadius: '10px',
	boxShadow: 'none',
	overflow: 'hidden',
};

const accordionHeaderSx = {
	px: 2,
	py: 1.5,
	backgroundColor: '#f8fafc !important',
	borderBottom: '1px solid #eef2f7',
};

const accordionTitleSx = {
	fontSize: '15px !important',
	fontWeight: '600 !important',
	color: '#1f2937',
};

const GrossRentHistory = ({ data = [], index, otherChanges }) => {
	const form = Form.useFormInstance();
	const effectiveDateHistory = form.getFieldValue('effectiveDateHistory');
	const containerSx =
		index === 0
			? {
					height: '100%',
					display: 'flex',
					flexDirection: 'column',
			  }
			: {
					height: '100%',
					display: 'flex',
					flexDirection: 'column',
					p: 2,
					border: '1px solid #e6ebf2',
					borderRadius: '10px',
					backgroundColor: '#ffffff',
			  };

	return (
		<Box sx={containerSx}>
			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
					gap: 1.5,
					flexWrap: 'wrap',
					justifyContent: 'space-between',
					mb: 1.5,
				}}
			>
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						gap: '8px',
						flexShrink: 0,
					}}
				>
					<Box
						sx={{
							width: '24px',
							height: '24px',
							borderRadius: '50%',
							backgroundColor: index === 0 ? '#4caf50' : '#ff9800',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							color: 'white',
							fontSize: '12px',
							fontWeight: 'bold',
						}}
					>
						{index === 0 ? '1' : index + 1}
					</Box>
					<Typography
						sx={{
							fontSize: '14px',
							fontWeight: 600,
							color: '#1f2937',
							whiteSpace: 'nowrap',
						}}
					>
						{index === 0 ? 'Initial - on creation:' : `${getOrdinalSuffix(index)} Modification:`}
					</Typography>
				</Box>

				<Box
					sx={{
						display: 'flex',
						gap: '6px',
						flexWrap: 'wrap',
						alignItems: 'center',
						justifyContent: 'flex-end',
					}}
				>
					<Chip
						label={`Effective Date: ${dayjs(effectiveDateHistory?.[index]).format('DD-MM-YYYY')}`}
						variant="outlined"
						size="small"
						sx={{
							fontSize: '11px',
							height: '24px',
							backgroundColor: '#f8fafc',
							borderColor: '#dbe3ee',
							flexShrink: 0,
						}}
					/>
					<Chip
						label={`IBR: ${otherChanges?.inputChangeDiscountRate}`}
						size="small"
						sx={{
							fontSize: '11px',
							backgroundColor: '#e8f5e9',
							height: '24px',
						}}
					/>
					<Chip
						label={`Payment Frequency: ${otherChanges?.paymentFrequency}`}
						size="small"
						sx={{
							fontSize: '11px',
							backgroundColor: '#fff3e0',
							height: '24px',
						}}
					/>
					<Chip
						label={`Payment Modality: ${otherChanges?.paymentTime?.toLowerCase() === 'start' ? 'Advance Basis' : 'Accrual Basis'}`}
						size="small"
						sx={{
							fontSize: '11px',
							backgroundColor: '#e3f2fd',
							height: '24px',
						}}
					/>
				</Box>
			</Box>

			<TableContainer
				sx={{
					flexGrow: 1,
					'& table, & th, & td': {
						border: '1px solid #e6ebf2',
						borderCollapse: 'collapse',
					},
					'& th, & td': {
						p: '8px 12px',
						fontSize: '13px',
					},
					'& td .ant-form-item': {
						marginBottom: '0px',
					},
					'& th': {
						fontWeight: 600,
						backgroundColor: '#f8fafc',
					},
					'& table': {
						width: '100%',
						tableLayout: 'fixed',
					},
				}}
			>
				<Table size="small" aria-label="Advance Amount table">
					<TableHead>
						<TableRow>
							<TableCell sx={{ width: '20%', textAlign: 'center' }}>From</TableCell>
							<TableCell sx={{ width: '20%', textAlign: 'center' }}>To</TableCell>
							<TableCell sx={{ width: '30%', textAlign: 'center' }}>Amount</TableCell>
							<TableCell sx={{ width: '30%', textAlign: 'center' }}>Notes</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{data.length > 0 ? (
							data.map((row, index) => {
								return (
									<TableRow key={index}>
										<TableCell style={{ textAlign: 'center' }}>{row.from}</TableCell>
										<TableCell style={{ textAlign: 'center' }}>{row.to}</TableCell>
										<TableCell style={{ textAlign: 'right', fontFamily: 'monospace' }}>{row.amount}</TableCell>
										<TableCell>{row.remarks || ''}</TableCell>
									</TableRow>
								);
							})
						) : (
							<TableRow>
								<TableCell colSpan={4} style={{ textAlign: 'center', padding: '24px' }}>
									No data available
								</TableCell>
							</TableRow>
						)}
					</TableBody>
				</Table>
			</TableContainer>
		</Box>
	);
};

const LeaseV9NewTrailModeHistory = ({ viewData, selectHistory }) => {
	const form = Form.useFormInstance();
	const [listLength, setListLength] = useState(0);
	const grossRentListSet = form.getFieldValue('grossRentListSet');

	useEffect(() => {
		setListLength(grossRentListSet?.length || 0);
	}, [grossRentListSet]);

	return (
		<>
			<CardAccordion
				sx={accordionSx}
				contentSX={{ p: 2 }}
				darkTitle={true}
				title="Lease Payment Schedule"
				typographySX={accordionTitleSx}
				customHeaderSX={accordionHeaderSx}
			>
				<Grid container spacing={2}>
					{grossRentListSet?.map((item, index) => (
						<Grid
							item
							xs={12}
							lg={
								index === 0 && listLength !== 2
									? 12
									: index === 0 && listLength === 2
										? 6
										: listLength > 2 && listLength % 2 === 0 && index === listLength - 1
											? 12
											: 6
							}
							key={index}
						>
							<GrossRentHistory data={item} index={index} otherChanges={viewData?.data?.changes[index]} />
						</Grid>
					))}
				</Grid>
			</CardAccordion>

			<CardAccordion
				title="Other Changes History"
				sx={accordionSx}
				contentSX={{ p: 2 }}
				customHeaderSX={accordionHeaderSx}
				typographySX={accordionTitleSx}
				darkTitle={true}
			>
				<Button
					type="primary"
					style={{
						height: '34px',
						paddingInline: '16px',
						fontSize: '13px',
						fontWeight: 600,
						borderRadius: '8px',
						display: 'flex',
						alignItems: 'center',
						boxShadow: 'none',
						marginLeft: 'auto',
						...(viewData?.history?.length <= 1
							? {
									backgroundColor: '#98a2b3',
									borderColor: '#98a2b3',
								}
							: {
									backgroundColor: '#2563eb',
									borderColor: '#2563eb',
								}),
					}}
					onClick={(e) => {
						e.stopPropagation();
						if (selectHistory) {
							selectHistory({ ...viewData, ...viewData?.data, id: viewData?._id });
						} else if (viewData?.selectHistory) {
							viewData.selectHistory({ ...viewData, ...viewData?.data, id: viewData?._id });
						}
					}}
				>
					Log
				</Button>
			</CardAccordion>
		</>
	);
};

export default LeaseV9NewTrailModeHistory;
